<template>
  <div class="carousel-cell">
    <span class="grades__label">{{ formattedGradesLabel }}</span>
    <div class="grades__list flex-col flex">
      <div v-for="grade in grades" :key="grade.id" class="grades__item">
        <div class="flex flex-col flex-1 pr-3">
          <span
            class="grades__item__subject"
            :style="{
              color: grade.gradeDescription.gradeCategory.color.background,
            }"
          >
            {{ grade.gradeDescription.gradeCategory.namePl }}
          </span>
          <span>{{ grade.gradeDescription.description }}</span>
        </div>
        <!-- show symbolic grades when
              - showPointsAs === 'symbol'
             or
              - _gradeFormat returns one of predefined symbols
        -->
        <div
          v-if="grade.grades?._gradeGroupCategory?.showPointsAs === 'symbol' ||
            ['@', '^', 'X', 'x'].includes(grade.grades._gradeFormat)"
          class="grades__item__grade"
          :class="{ 'grade__null': grade.grades._gradeFormat === '' }"
          :style="{
            'background-color':
              grade.gradeDescription.gradeCategory.color.background,
            'border-color':
              grade.gradeDescription.gradeCategory.color.background,
          }"
        >
          <img
            v-if="grade.grades._gradeFormat === '@'"
            src="@/assets/images/grades/symbols/refresh.svg"
            class="grades__item__grade--symbol"
          />
          <img
            v-else-if="grade.grades._gradeFormat === '^'"
            src="@/assets/images/grades/symbols/arrow.svg"
            class="grades__item__grade--symbol"
          />
          <img
            v-else-if="grade.grades._gradeFormat === 'X'"
            src="@/assets/images/grades/symbols/cross.svg"
            class="grades__item__grade--symbol"
          />
          <template v-else>
            <span class="font21">
              {{ grade.grades._gradeFormat }}
            </span>
          </template>
        </div>
        <div
          v-else
          class="grades__item__grade"
          :class="{ 'grade__null': grade.grades._gradeFormat === '' }"
          :style="{
            'background-color':
              grade.gradeDescription.gradeCategory.color.background,
            'border-color':
              grade.gradeDescription.gradeCategory.color.background,
          }"
        >
          <span class="font14">
            {{ grade.grades._gradeFormat }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  props: {
    gradesLabel: String,
    grades: Array,
  },

  computed: {
    formattedGradesLabel() {
      let formattedLabel = '';

      if (this.gradesLabel.includes('semester')) {
        formattedLabel = this.$t('grades.semester_exam');
      } else if (this.gradesLabel.includes('annual')) {
        formattedLabel = this.$t('grades.annual_exam');
      } else {
        formattedLabel = moment(this.gradesLabel, 'YYYY-MM').format('MMMM');
      }
      return formattedLabel;
    },
  },
};
</script>

<style lang="scss" scoped>
.carousel-cell {
  animation: fadeIn 0.2s cubic-bezier(0.56, 0.33, 0.54, 0.95) both;
}

.grades__label {
  @apply text-center text-sm mb-6;
  @media screen and (min-width: 992px) {
    @apply text-left mb-4 text-2xl;
  }
}

.grades__list {
  @apply bg-white w-full rounded-lg;
}

.grades__item {
  @apply flex justify-start items-center p-4 py-4;
  border-bottom: 1px solid #ececec;
  &:last-child {
    border: none;
  }
  @media screen and (min-width: 992px) {
    @apply py-3;
  }
  &__subject {
    @apply font-semibold pr-2 pb-1;
  }
  &__grade {
    @apply flex justify-center items-center text-white text-center;
    border: 1.5px solid #000;
    width: 36px;
    height: 36px;
    border-radius: 4px;
    @media screen and (min-width: 992px) {
      width: 40px;
      height: 40px;
    }
    &--symbol {
      height: 21px;
    }
    .font21 {
      font-size: 21px;
    }
    .font14 {
      font-size: 14px;
      font-weight: bold;
    }
  }
}

.grade__null {
  background: white !important;
}
</style>
